import { render, staticRenderFns } from "./tezhengfenxiChats.vue?vue&type=template&id=2dd68823&scoped=true"
import script from "./tezhengfenxiChats.vue?vue&type=script&lang=js"
export * from "./tezhengfenxiChats.vue?vue&type=script&lang=js"
import style0 from "./tezhengfenxiChats.vue?vue&type=style&index=0&id=2dd68823&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd68823",
  null
  
)

export default component.exports